{
  "achievements": "الإنجازات",
  "advanced": "متقدم",
  "all": "الكل",
  "antiFakeProtection": "الحماية من الاحتيال",
  "antiFakeProtectionText": "يتم التحقق من جميع المطالبات على مستوى الخادم لمنع النشاط الاحتيالي.",
  "approvedClaims": "المطالبات المعتمدة",
  "approvedExalt": "EXALT المعتمد",
  "beginner": "مبتدئ",
  "claim5Exalt": "استلم 5 EXALT",
  "claimDailyMining": "المطالبة بمكافأة التعدين اليومية",
  "claimDailyRewardDesc": "اطلب مكافأتك اليومية البالغة 5 EXALT.",
  "claimDailyRewardDescription": "احصل على 5 EXALT يوميًا.",
  "claimFailed": "فشلت المطالبة.",
  "claimedToday": "تم الاستلام اليوم",
  "completed": "مكتمل",
  "completedTasks": "الدروس المكتملة",
  "cooldown": "فترة الانتظار",
  "correctAnswerRewardAdded": "إجابة صحيحة! تمت إضافة المكافأة.",
  "cryptoBasics": "أساسيات العملات الرقمية",
  "dailyMiningRate": "معدل التعدين اليومي",
  "dailyReward": "المكافأة اليومية",
  "dailyRewardClaimed": "تم استلام المكافأة اليومية.",
  "dailyStreak": "السلسلة اليومية",
  "days": "أيام",
  "distributed": "موزّع",
  "downloadCertificate": "تحميل الشهادة",
  "duration": "المدة",
  "exaltExchangeUser": "مستخدم Exalt Exchange",
  "exaltMiningPool": "مجمع تعدين EXALT",
  "failedLoadRewards": "فشل تحميل المكافآت.",
  "firstLesson": "الدرس الأول",
  "intermediate": "متوسط",
  "learnEarn": "تعلّم واربح",
  "learnEarnSubtitle": "شاهد الدروس وأكمل الاختبارات واربح عملات EXALT.",
  "learnEarnTitle": "تعلم واربح",
  "learnerAchievement": "إنجاز المتعلم",
  "learningLevel": "مستوى التعلم",
  "learningProgress": "تقدم التعلم",
  "lessonCompleted": "تم إكمال الدرس بنجاح.",
  "level": "المستوى",
  "loadingLessons": "جارٍ تحميل الدروس...",
  "locked": "مغلق",
  "masterAchievement": "إنجاز الخبير",
  "miningProtectionNote": "مكافآت التعدين محمية من المطالبات الآلية والمكررة.",
  "miningRewardSubmitted": "تم إرسال مطالبة مكافأة التعدين.",
  "myRewardClaims": "مطالباتي بالمكافآت",
  "noAchievements": "لا توجد إنجازات",
  "noActivityYet": "لا يوجد نشاط",
  "noMinersYet": "لا يوجد معدّنون بعد.",
  "noReferrersYet": "لا يوجد محيلون بعد.",
  "noRewardClaimsYet": "لا توجد مطالبات مكافآت بعد.",
  "oneClaimEvery24Hours": "يُسمح بمطالبة واحدة كل 24 ساعة.",
  "optionAfterPayment": "بعد تأكيد الدفع",
  "optionAnyTime": "في أي وقت",
  "optionBeforePayment": "قبل الدفع",
  "optionDeleteTokens": "حذف العملات",
  "optionLockTokens": "قفل العملات مقابل مكافآت",
  "optionPrivateKey": "مشاركة المفتاح الخاص",
  "optionProtectWallet": "حماية مفاتيح المحفظة",
  "optionSendTokens": "إرسال العملات",
  "optionUnknownLinks": "استخدام روابط مجهولة",
  "p2pSafety": "أمان P2P",
  "pendingValue": "القيمة المعلقة",
  "questionCrypto": "ما هي أكثر قاعدة أماناً في العملات الرقمية؟",
  "questionP2p": "متى يجب عليك تحرير العملة الرقمية في P2P؟",
  "questionStaking": "ماذا يعني Staking؟",
  "quiz": "الاختبار",
  "recentActivity": "آخر النشاطات",
  "referralRewardNote": "تُضاف مكافآت الإحالة بعد تحقق المسؤول.",
  "referralRewardPool": "مجمع مكافآت الإحالة",
  "referrals": "الإحالات",
  "reward": "مكافأة",
  "rewardClaim": "مطالبة المكافأة",
  "rewardClaimFailed": "فشل المطالبة بالمكافأة.",
  "rewardClaimed": "تمت المطالبة بالمكافأة بنجاح.",
  "rewardCompleted": "تم إكمال المكافأة.",
  "rewardFailed": "فشلت المطالبة بالمكافأة.",
  "searchLessons": "ابحث عن الدروس...",
  "securityReview": "مراجعة أمنية",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "stakingGuide": "دليل الستيكينغ",
  "startLesson": "ابدأ الدرس",
  "submitQuizClaimReward": "إرسال الاختبار واستلام المكافأة",
  "submitting": "جارٍ الإرسال...",
  "todayClaims": "مطالبات اليوم",
  "topLearners": "أفضل المتعلمين",
  "topMiners": "أفضل المعدّنين",
  "topReferrers": "أفضل المحيلين",
  "totalClaims": "إجمالي المطالبات",
  "totalPool": "إجمالي المجمع",
  "totalRewards": "إجمالي المكافآت",
  "used": "مستخدَم",
  "videoCryptoBasics": "ما هي العملات الرقمية وكيف تعمل المنصات؟",
  "videoP2pSafety": "كيفية التداول بأمان مع مستخدمي P2P",
  "videoStakingGuide": "كيف تعمل مكافآت الستيكينغ",
  "viewAgain": "إعادة المشاهدة",
  "wrongAnswerTryAgain": "إجابة خاطئة، حاول مرة أخرى.",
  "xpPoints": "نقاط XP",
  "you": "أنت"
}